import React from 'react';
import type { IconProps } from '../types';

export const Download = (props: IconProps) => (
  <svg
    width="256px"
    height="256px"
    viewBox="0 0 24.00 24.00"
    xmlns="http://www.w3.org/2000/svg"
    fill="#ffffff"
    stroke="#ffffff"
    {...props}
  >
    <g
      id="SVGRepo_bgCarrier"
      strokeWidth="0"
    />

    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <g id="SVGRepo_iconCarrier">
      {' '}
      <title />{' '}
      <g id="Complete">
        {' '}
        <g id="download">
          {' '}
          <g>
            {' '}
            <path
              d="M3,12.3v7a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2v-7"
              fill="none"
              stroke="#ffffff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2.4"
            />{' '}
            <g>
              {' '}
              <polyline
                fill="none"
                points="7.9 12.3 12 16.3 16.1 12.3"
                stroke="#ffffff"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2.4"
              />{' '}
              <line
                fill="none"
                stroke="#ffffff"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2.4"
                x1="12"
                x2="12"
                y1="2.7"
                y2="14.2"
              />{' '}
            </g>{' '}
          </g>{' '}
        </g>{' '}
      </g>{' '}
    </g>
  </svg>
);

export default Download;
